import React from 'react';
import Card from '@mui/material/Card';
import Link from '@mui/material/Link';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import TableViewIcon from '@mui/icons-material/TableView';
import { Link as RouterLink } from 'react-router-dom';
import Box from '@mui/material/Box';
import AppConfig from '../../config';
const CardWrapper = ({ name,display_name, description }) => {
  return (
    <Link
      
        component={RouterLink}
        to={`/mastertables/${name}`}
        sx={{ textDecoration: 'none',color:"black",height:"100%" }}
        >
    <Card elevation={3} sx={{ height:"100px",borderRadius:"8px",transition: '0.3s', // Smooth transition for the hover effect
                '&:hover': {
                    elevation: 10, // Change elevation on hover
                    backgroundColor: '#ebebeb', // Change background color on hover
                    transition:".3s ease-out"
                },}} className="card">
      <CardContent className="card-content">
        <Box display="flex" padding="2" alignItems="flex-start">
            <TableViewIcon sx={{ fontSize: '64px',color:`${AppConfig.colorPalette.primary.main}` }}/>
            <Box display="flex" flexDirection="column" gap="1" sx={{overflow:"Hidden"}}>
            <Typography sx={{
              fontSize:"18px",
              fontStyle:"Bold",
              overflow: "hidden",       // Ensures overflow is hidden
              textOverflow: "ellipsis",  // Adds ellipsis for clipped text
              whiteSpace: "nowrap",     // Prevents text wrapping
              }}
              >
                {display_name}
            </Typography>
            <Typography color="textSecondary" sx={{
              fontSize:"12px",
              // overflow: "hidden",       // Ensures overflow is hidden
              // textOverflow: "ellipsis",  // Adds ellipsis for clipped text
              // whiteSpace: "wrap",     // Prevents text wrapping
              }}>
            {description}
            </Typography>
            </Box>
        </Box>
      </CardContent>
    </Card>
     </Link>
  );
};

export default CardWrapper;